import { useTranslations } from "@/contexts/Translation";
import Link from "../Link/Link";
import List from "../List/List";
import Section from "../Section";
import Quote from "../Quote/Quote";
import { useState } from "react";
import { FeedbackJourneyLogo } from "../Icons/Logo";
import styles from "./Footer.module.css";

const quotes = [
  { author: "Ken Blanchard", text: "Feedback is the breakfast of champions." },
  { author: "Bill Gates", text: "We all need people who will give us feedback. That's how we improve." },
  {
    author: "Some founder of a large EV company",
    text: "I think it's very important to have a feedback loop, where you're constantly thinking about what you've done and how you could be doing it better..",
  },
  { author: "Brian Tracy", text: "The more feedback you give to people, the better it is, as long as the feedback is objective and not critical." },
  { author: "George Raveling", text: "The best feedback is what we don't want to hear." },
  { author: "Andy Murray", text: "It's always nice to get good feedback, and a bit of encouragement can go a long way." },
  { author: "Stephen R. Covey", text: "Feedback often tells you more about the person who is giving it than about you." },
  { author: "Naval Ravikant", text: "Clear thinkers take feedback from reality, not society." },
  { author: "Steven D. Levitt", text: "The key to learning is feedback. It is nearly impossible to learn anything without it." },
  { author: "Ed Batista", text: "Make feedback normal. Not a performance review." },
  { author: "Doc Rivers", text: "Average players want to be left alone. Good players want to be coached. Great players want to be told the truth." },
  { author: "Henrik Ceder", text: "Feedback is the compass for greatness; it tells you what to avoid, what to learn, and where to excel." },
  { author: "Robert Allen", text: "There is no failure. Only feedback." },
  { author: "Ann Marie Houghtailing", text: "Feedback is a free education to excellence. Seek it with sincerity and receive it with grace." },
  { author: "Adam Grant", text: "Withholding feedback is choosing comfort over growth." },
  { author: "Grant Wiggins", text: "Learners need endless feedback more than they need endless teaching." },
  { author: "Patrick Lencioni", text: "Direct and personal feedback really is the simplest and most effective way of motivation." },
  { author: "Brené Brown", text: "If we shield ourselves from all feedback, we stop growing." },
];

export const Footer = () => {
  const t = useTranslations("footer");
  const [quote] = useState(quotes[Math.floor(Math.random() * quotes.length)]);
  const menuItems = [
    { href: "https://feedbackjourney.com/privacy", text: t("privacy") },
    { href: "https://feedbackjourney.com/cookie-policy", text: t("cookies") },
    { href: "https://feedbackjourney.com/agreement", text: t("terms") },
    { href: "/contact", text: t("contact") },
  ];

  return (
    <footer className={styles.footer}>
      <Section className={styles.content}>
        <Quote className={styles.quote} iconColor='var(--color-text-on-primary)' from={quote.author}>
          {quote.text}
        </Quote>
        <div className={styles.menu}>
          <List
            items={menuItems.map((item) => (
              <Link className={styles.link} href={item.href} key={item.href}>
                {item.text}
              </Link>
            ))}
            className={styles.list}
          />
          <Link className={[styles.link, styles.logoLink].join(" ")} href='/' aria-label='Feedback Journey'>
            <FeedbackJourneyLogo w={135} />
          </Link>
          <span>Feedback Journey</span>
        </div>
      </Section>
    </footer>
  );
};
